import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableRestockingComponent from '../components/TableRestockingComponent';
import { validateSession } from  '../utils/functions';
import { navigateTo } from '../utils/navigation';
import "react-datepicker/dist/react-datepicker.css";

// ENI-32: esta pantalla dejó de pagar. El estado de pago vive en la factura del proveedor y el
// pago —con su total, su resumen copiable y su confirmación— vive en "Facturas a pagar". Tener
// las dos puertas era el problema: se pagaba desde acá, la factura seguía diciendo pendiente y
// la deuda del proveedor no se movía. Acá queda la entrada de mercadería y su consulta.
class RestockingPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            loading: false,
            checked: !!localStorage.getItem('token'),
            dateSelected: new Date(),
            role: cachedRole,
            products: {},
        }
	}

	async componentDidMount() {
        let role = await validateSession(true)
        this.setState({ checked: true, role:  role});
    }

    addStock = () => {
        navigateTo('/addRestocking');
    }

    irAFacturas = () => {
        navigateTo('/providerInvoices');
    }

	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={13} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4" style={{paddingBottom: '80px'}}>
                                <HeaderComponent title="Stocks" subtitle="Reposición de stock"/>
                                {/* El pago se movió: se deja el camino a la vista para quien venía
                                    a esta pantalla a pagar, en vez de que el botón simplemente
                                    desaparezca sin explicación. */}
                                {this.state.role === 1 ? (
                                    <div className="mb-3">
                                        <button type="button" className="btn btn-sm btn-white" onClick={this.irAFacturas}>
                                            Ir a Facturas a pagar
                                        </button>
                                        <small className="text-muted ml-2">
                                            Los pagos a proveedores se hacen desde ahí.
                                        </small>
                                    </div>
                                ) : null}
                                {/* ENI-199: type="retail" — sin esto, las reposiciones de
                                    insumos de cafetería se cuelan en esta grilla. */}
                                <TableRestockingComponent role={this.state.role} type="retail"/>
                            </div>
                        </main>
                    </div>
                    <div onClick={() => this.addStock()} class="color-switcher-toggle animated pulse infinite">
                        <i class="material-icons">add</i>
                    </div>
                </div>
            );
        }
    }
}

export default RestockingPage;
